import { useMemo } from 'react';
import { useAppSelector } from './store';
import { getCurrentUser } from '../reducers/authSlice';

function useAuth() {

  const user = useAppSelector(getCurrentUser);
  console.log(user,"useruser")
  return useMemo(() => user, [user]);
}

export default useAuth;
